<template>
<!-- 零售仓储列表页面 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'retail')">
            <div slot="header">
                <a-form :form="filterForm" layout="inline" class="store-one-form">
                <a-form-item label="商品编号">
                    <a-input placeholder="请输入" v-decorator="['serialNum']"></a-input>
                </a-form-item>
                <a-form-item label="商品名称">
                    <a-input placeholder="请输入" v-decorator="['name']"></a-input>
                </a-form-item>
                <a-form-item label="商品类型">
                    <a-select v-decorator="['cateId',{rules: [{ required: false }]}]" placeholder="请选择">
                    <a-select-option
                        v-for="(item, index) in goodsCate"
                        :key="index"
                        :value="item.id"
                    >{{item.name}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="仓库名称">
                    <a-select v-decorator="['storeageId',{rules: [{ required: false }]}]" placeholder="请选择">
                    <a-select-option
                        v-for="(item, index) in wareHouseList"
                        :key="index"
                        :value="item.id"
                    >{{item.name}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item class="wrap-header-button">
                    <a-button class="mr8" type="primary" @click="filterRetail">筛选</a-button>
                    <a-button @click="handleReset">重置</a-button>
                </a-form-item>
                </a-form>
            </div>
            <div class="retail">
                <a-button v-if="getBtnByAuth('tradeStock')" class="mb16" type="primary" @click="warehousing(1)">商品入库</a-button>
                <a-button v-if="getBtnByAuth('outbound')" class="mb16" type="primary" @click="warehousing(2)">出库申请</a-button>
                <a-button v-if="getBtnByAuth('allocate')" class="mb16" type="primary" @click="warehousing(3)">调拨申请</a-button>
                <a-button v-if="getBtnByAuth('stockTaking')" class="mb16" type="primary" @click="warehousing(4)">库存盘点</a-button>
                <a-table
                bordered
                :dataSource="retailList"
                :columns="columns"
                :pagination="pagination"
                :rowKey="record => record.id"
                @change="changePage"
                >
                <span slot="specifica" slot-scope="specifica">{{ specifica || "-" }}</span>
                <span slot="action" slot-scope="a,row">
                    <!-- <span v-if="getBtnByAuth('addBound')">
                        <a class="text-primary" @click="addBound(row)">添加库存</a>
                        <a-divider type="vertical"/>
                    </span> -->
                    <span v-if="getBtnByAuth('productDetail')">
                        <a class="text-primary" @click="toDetail(row)">详情</a>
                        <a-divider type="vertical"/>
                    </span>
                    <span v-if="getBtnByAuth('productUpdate')">
                        <a class="text-primary" @click="toEditerRow(row)">编辑</a>
                        <a-divider type="vertical"/>
                    </span>
                    <a v-if="getBtnByAuth('tradeRecord')" class="text-primary" @click="toTradeRecord(row)">出入库记录</a>
                </span>
                </a-table>
                <a-modal title="" centered v-model="editerVisible" @ok="confirmEdit">
                    <a-form :form="editForm" @submit="confirmEdit">
                        <a-form-item label="商品编号：" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                            <a-input
                                @blur="isNumExist"
                                v-decorator="[ 'serialNum',{rules: [{ required: false,}]}]"
                                placeholder="请输入"
                            />
                        </a-form-item>
                        <a-form-item label="商品名称：" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                            <a-input @blur="isNameExist" v-decorator="[ 'name',{rules: [{ required: false,}]}]" placeholder="请输入"/>
                        </a-form-item>
                        <a-form-item label="商品类型：" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                            <a-select
                                v-decorator="['goodsType', {rules: [{ required: false,}]}]"
                                placeholder="请选择"
                            >
                                <a-select-option
                                :value="item.id"
                                v-for="item in goodsCate"
                                :key="item.id"
                                >{{item.name}}</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item label="商品规格：" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                            <a-input
                                v-decorator="[ 'specifica',{rules: [{ required: false,}]}]"
                                placeholder="请输入"
                            />
                        </a-form-item>
                        <a-form-item label="商品单位：" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                            <a-select
                                v-decorator="['unitId', {rules: [{ required: false,}]}]"
                                placeholder="请选择"
                            >
                                <a-select-option
                                :value="item.id"
                                v-for="item in goodsUnit"
                                :key="item.id"
                                >{{item.unit}}</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item label="商品成本价：" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                            <a-input
                                v-decorator="[ 'costPrice',{rules: [{ required: false,}]}]"
                                suffix="元"
                                placeholder="请输入"
                            />
                        </a-form-item>
                        <a-form-item label="商品售卖价：" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                            <a-input
                                v-decorator="[ 'sellPrice',{rules: [{ required: false,}]}]"
                                suffix="元"
                                placeholder="请输入"
                            />
                        </a-form-item>
                    </a-form>
                </a-modal>
                <a-modal title="添加库存" v-model="addBoundVisible" @ok="addBoundSave">
                    <div class="add-bound">
                        <a-row>
                            <a-col :span="12"> 商品编号：{{goodsDetail.serialNum}} </a-col>
                            <a-col :span="12"> 商品名称：{{goodsDetail.name}} </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="12"> 商品类型：{{goodsDetail.goodsType}} </a-col>
                            <a-col :span="12"> 商品规格：{{goodsDetail.specifica}} </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="12"> 商品单位：{{goodsDetail.unit}} </a-col>
                            <a-col :span="12"> 仓库名称：{{goodsDetail.warehouseName}} </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="12"> 当前库存量：{{goodsDetail.currentInventory}} </a-col>
                        </a-row>
                    </div>
                    <div>
                        本次入库数：<a-input-number
                                v-model="goodsDetail.num"
                                :min="1"
                                :precision="0"
                                suffix="个"
                                placeholder="请输入"
                            />
                    </div>
                </a-modal>
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    export default {
        name: 'retail',
        components: {},
        props: {},
        data() {
            const columns = [
                {
                    title: '商品编号',
                    dataIndex: 'serialNum',
                    scopedSlots: {
                        customRender: 'serialNum'
                    }
                },
                {
                    title: '商品名称',
                    dataIndex: 'name'
                },
                {
                    title: '商品类型',
                    dataIndex: 'goodsType'
                },
                {
                    title: '商品规格',
                    dataIndex: 'specifica',
                    scopedSlots: { customRender: 'specifica' }
                },
                {
                    title: '单位',
                    dataIndex: 'unit'
                },
                {
                    title: '仓库名称',
                    dataIndex: 'warehouseName'
                },
                {
                    title: '当前库存量',
                    dataIndex: 'currentInventory'
                },
                {
                    title: '总入库量',
                    dataIndex: 'totalInventory'
                },
                {
                    title: '总销售量',
                    dataIndex: 'totalSales'
                },
                {
                    title: '操作',
                    dataIndex: 'actions',
                    scopedSlots: { customRender: 'action' }
                }
            ];
            return {
                filterForm: this.$form.createForm(this),
                editForm: this.$form.createForm(this),
                columns,
                retailList: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                editerVisible: false,
                editIndex: 0,
                goodsCate: [], //商品类别
                goodsUnit: [],
                wareHouseList: [],
                wareHouseTypeList: [],
                addBoundVisible: false,
                goodsDetail: {},
                storeageId: ''
          };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            //分页回调
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getRetailList();
            },
            //筛选
            filterRetail() {
                this.pagination.current = 1;
                this.filterForm.validateFields((err, values) => {
                    if (!err) {
                        this.getRetailList();
                    }
                });
            },
            //重置筛选
            handleReset() {
                this.filterForm.resetFields();
                this.getRetailList();
            },
            // 页面跳转
            // 1是商品入库，
            // 2是出库申请，
            // 3是调拨申请，
            // 4是库存盘点
            warehousing(path) {
                if (path == 1) {
                    this.$router.push({ name: 'tradeStock' });
                }
                if (path == 2) {
                    this.$router.push({ name: 'outbound' });
                }
                if (path == 3) {
                    this.$router.push({ name: 'allocate' });
                }
                if (path == 4) {
                    this.$router.push({ name: 'stockTaking' });
                }
            },
            toDetail(row) {
                this.$router.push({ name: 'productDetail', params: { id: row.id ,storeageId: row.storeageId} });
            },
            // 添加库存
            addBound(row) {
                this.addBoundVisible = true
                this.goodsDetail = row
            },
            addBoundSave() {
                if(!this.goodsDetail.num) {
                    this.$message.error('请输入本次入库数')
                    return false
                }

                this.$api.storage.addStockNum({
                    body: {
                        goodsId: this.goodsDetail.id,
                        num: this.goodsDetail.num,
                    }
                }).then(res => {
                    this.$message.success('操作成功')
                    this.getRetailList()
                    this.addBoundVisible = false
                });
            },
            //出入库记录
            toTradeRecord(row) {
                this.$router.push({
                    name: 'tradeRecord',
                    query: { 
                        goodsId: row.id, 
                        storeageId: row.storeageId,
                        name: row.name,
                        storagName: row.warehouseName 
                    }
                });
            },
            //确认编辑
            confirmEdit(e) {
                e.preventDefault();
                this.editForm.validateFields((err, values) => {
                    if (!err) {
                        this.editerVisible = false;
                        if (typeof values.goodsType == 'number') {
                            values.cateId = values.goodsType;
                        }
                        delete values.goodsType;
                        this.updateRetail(values);
                    }
                });
            },
            //编辑行 商品详情
            toEditerRow(row) {
                this.editerVisible = true;
                this.editIndex = row.id;
                this.storeageId = row.storeageId;
                    
                // const goodsUnit = (this.goodsUnit.filter(item => item.unit == res.unit))[0]
                var value = {
                    name: row.name,
                    serialNum: row.serialNum,
                    specifica: row.specifica,
                    sellPrice: row.sellPrice,
                    costPrice: row.costPrice,
                    unitId: Number(row.unitId),
                    goodsType: row.typeId,
                };
                this.$nextTick(() => {
                    this.editForm.setFieldsValue(value);
                });
            },
            //获取零售仓储管理列表
            getRetailList() {
                if(!this.shopId) return
                this.filterForm.validateFields((err, values) => {
                    if (err) return;
                    values.shopId = this.shopId
                    this.$api.storage.getRetailList({ body: {
                        ...values,
                        pageNum: this.pagination.current,
                        pageSize: this.pagination.pageSize
                    } }).then(res => {
                        this.retailList = res.data;
                        this.pagination.total = res.total;
                        this.getWarehouseList()
                    });
                })
            },
            updateRetail(params) {
                params.id = this.editIndex;
                params.shopId = this.shopId;
                this.$api.storage.updateRetail({ body: params }).then(res => {
                    this.$message.success('操作成功')
                    this.getRetailList();
                });
            },
            //商品类别
            goodsCateList() {
                this.$api.storage.goodsCateList().then(res => {
                    this.goodsCate = res;
                });
            },
            //商品单位
            goodsUnitList() {
                this.$api.storage.goodsUnitList().then(res => {
                    this.goodsUnit = res;
                });
            },
            //仓库列表
            getTypeList() {
                this.$api.storage.getTypeList().then(res => {
                    this.wareHouseTypeList = res;
                });
            },
            getWarehouseList() {
                if(!this.shopId) return
                this.$api.storage.getWarehouseList({params: {
                    shopId: this.shopId
                }}).then(res => {
                    this.wareHouseList = res;
                });
            },
            // 检查商品编号是否存在 存在返回true 否false
            isNumExist() {
                let values = {
                    id: this.editIndex,
                    warehouseId: this.storeageId,
                    serialNum: this.editForm.getFieldValue('serialNum'),
                }
                this.$api.storage.isNumExistGoods({ body: values }).then(res => {
                    if(res) {
                        this.$message.error('商品编号不能重复，请重新输入')
                    }
                });
            },
            // 检查商品名称是否存在 存在返回true 否false
            isNameExist() {
                let values = {
                    id: this.editIndex,
                    warehouseId: this.storeageId,
                    name: this.editForm.getFieldValue('name'),
                }
                this.$api.storage.isNameExist({ body: values }).then(res => {
                    if(res) {
                        this.$message.error('商品名称不能重复，请重新输入')
                    }
                });
            },
        },
        created() {},
        mounted() {
            this.getRetailList();
            this.goodsCateList();
            this.goodsUnitList();
            this.getTypeList();
        },
        watch: {
            '$route'(val) {
                val.name == 'retail' && this.getRetailList();
            },
            'shopId'() {
                this.getRetailList()
            }
        }
    };
</script>
<style lang="scss">
    .retail {
        background-color: #fff;
        padding: 24px 32px;
        border-radius: 2px;
    }
    .add-bound {
        background: rgba(250,250,250,1);
        border-radius: 4px;
        padding: 16px;
        line-height: 34px;
        margin-bottom: 16px;
    }
</style>